import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_IndividualSvsPlan = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_IndividualSvsPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Individual Service Plan</h3></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>ID Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtIdNumber' name='txtIdNumber' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Admission Date:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date of Plan Implementation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtAdmissionDate' name='txtAdmissionDate' className='add-only w-200 custom-add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDatePlanImplementation' name='txtDatePlanImplementation' className='add-only w-200 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNew' name='cbNew' className='add-only' value='New' /> New &nbsp;
                            <input type='checkbox' id='cbReWrite' name='cbReWrite' className='add-only' value='ReWrite' /> Re-Write &nbsp;
                            <input type='checkbox' id='cbAddendum' name='cbAddendum' className='add-only' value='Addendum' /> Addendum

                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>INDIVIDUAL'S STRENGTHS:</span>
                    <textarea id='txtIndivisualStrengths' name='txtIndivisualStrengths' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>LONG TERM GOALS:</span>
                    <span className='small'>(include hopes/dreams/ goals)</span>
                    <textarea id='txtLongTermGoals' name='txtLongTermGoals' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>SHORT TERM GOALS:</span>
                    <textarea id='txtShortTermGoals' name='txtShortTermGoals' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>IDENTIFIED BARRIERS:</span>
                    <span className='small'>(Based on Functional Assessment)</span>
                    <textarea id='txtIdentifiedBarriers' name='txtIdentifiedBarriers' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>INDIVIDUAL'S AREAS OF NEED:</span>
                    <textarea id='txtIndividualAreaNeed' name='txtIndividualAreaNeed' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Area of needed support/observable behaviors/symptoms:</span>
                    <textarea id='txtObservableBehaviors' name='txtObservableBehaviors' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>How do needs/behaviors/symptoms create functionnal limitations for the person?</span>
                    <textarea id='txtFunctionnal' name='txtFunctionnal' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Duration:</span>
                    <input type='text' name='txtDuration' id='txtDuration' className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Frequency:</span>
                    <input type='text' name='txtFrequency' id='txtFrequency' className='add-only' />
                </p>
                <p>
                    <b>INDIVIDUALIZED PLAN FOR SERVICES</b>
                </p>
                <p>
                    <span className='eleHeader'>Objective #1:</span>
                    <textarea id='txtObjective_1' name='txtObjective_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_1' name='txtInterventions_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_1' name='txtServiceArea_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_1' name='txtCriteria_1' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_1' name='txtInitiation_1' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_1' name='txtTarget_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_2' name='txtInterventions_2' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_2' name='txtServiceArea_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_2' name='txtCriteria_2' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_2' name='txtInitiation_2' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_2' name='txtTarget_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_3' name='txtInterventions_3' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_3' name='txtServiceArea_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_3' name='txtCriteria_3' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_3' name='txtInitiation_3' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_3' name='txtTarget_3' className='add-only' /></td>
                    </tr>
                    </table>

                <p>
                    <span className='eleHeader'>Objective #2:</span>
                    <textarea id='txtObjective_2' name='txtObjective_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_4' name='txtInterventions_4' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_4' name='txtServiceArea_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_4' name='txtCriteria_4' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_4' name='txtInitiation_4' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_4' name='txtTarget_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_5' name='txtInterventions_5' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_5' name='txtServiceArea_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_5' name='txtCriteria_5' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_5' name='txtInitiation_5' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_5' name='txtTarget_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_6' name='txtInterventions_6' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_6' name='txtServiceArea_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_6' name='txtCriteria_6' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_6' name='txtInitiation_6' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_6' name='txtTarget_6' className='add-only' /></td>
                    </tr>
                    </table>

                <p>
                    <span className='eleHeader'>Objective #3:</span>
                    <textarea id='txtObjective_3' name='txtObjective_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_7' name='txtInterventions_7' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_7' name='txtServiceArea_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_7' name='txtCriteria_7' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_7' name='txtInitiation_7' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_7' name='txtTarget_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_8' name='txtInterventions_8' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_8' name='txtServiceArea_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_8' name='txtCriteria_8' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_8' name='txtInitiation_8' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_8' name='txtTarget_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Interventions</span></td>
                        <td className='w-375'><span className='eleHeader'>Service Area Assigned</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtInterventions_9' name='txtInterventions_9' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtServiceArea_9' name='txtServiceArea_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Criteria / Outcomes for Completion</span></td>
                        <td className='w-187'><span className='eleHeader'>Initiation Date:</span></td>
                        <td className='w-187'><span className='eleHeader'>Target Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCriteria_9' name='txtCriteria_9' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtInitiation_9' name='txtInitiation_9' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='date' id='txtTarget_9' name='txtTarget_9' className='add-only' /></td>
                    </tr>

                </table>

                <p>
                    <b>DIAGNOSIS</b>
                </p>

                <p>
                    <span className='eleHeader'>Primary Diagnosis(es):</span>
                    <textarea id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Secondary Diagnosis(es):</span>
                    <textarea id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Community Support has been offered to me and I choose:</span>

                    <input type='radio' id='rbCommunitySupport_Yes' name='rbCommunitySupport' className='add-only' value='Yes' /> Yes, I do want to participate (see Recovery Support Plan) &nbsp;
                    <input type='text' id='txtInitialsIndividual' name='txtInitialsIndividual' className='add-only w-250 custom-add-only' /> &nbsp;
                    (initials of individual receiving services)

                    <br />
                    <input type='radio' id='rbCommunitySupport_No' name='rbCommunitySupport' className='add-only' value='No' /> No, I do NOT want to participate &nbsp;
                    <input type='text' id='txtInitialsIndividual2' name='txtInitialsIndividual2' className='add-only w-250 custom-add-only' /> &nbsp;
                    (initials of individual receiving services)
                </p>


                <table>
                    <tr>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                    </tr>
                    <tr>
                        <td className='small w-180'>Individual Receiving Services:</td>
                        <td className='small w-180'>Date:</td>
                        <td className='small w-180'>Parent / Legal Guardian:</td>
                        <td className='small w-180'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                    </tr>
                    <tr>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                    </tr>
                    <tr>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                    </tr>
                    <tr>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                    </tr>
                    <tr>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                    </tr>
                    <tr>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                        <td className='signature w-180'></td>
                    </tr>
                    <tr>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                        <td className='small w-180'>Signature / Credentials:</td>
                        <td className='small w-180'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-525'></td>
                        <td className='signature w-200'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-525'>Physician / Clinical Psychologist / Nurse Practitioner, LCSW, LMFT, LPC, PA, Alzheimer's Day Program Supervisor:</td>
                        <td className='small w-200'>Date:</td>
                    </tr>

                </table>


            </div>
        </form >

    )
}











